const sizes = ['B', 'KiB', 'MiB', 'GiB', 'TiB'];
export default (bytes, digits = 2, separator = ' ') => {
    if (bytes === 0) {
        return 'n/a';
    }
    // @ts-expect-error TS2345: Argument of type 'number' is not assignable to parameter of type 'string'.
    const unit = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10);
    if (unit === 0) {
        return `${bytes} ${sizes[unit]})`;
    }
    return `${parseFloat((bytes / 1024 ** unit).toFixed(digits))}${separator}${sizes[unit]}`;
};
